const sanitizeFilenamePart = (
  value: string | null | undefined,
  fallback: string
): string => {
  const sanitized = (value ?? "")
    .trim()
    .replace(/[^a-zA-Z0-9-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "");
  return sanitized || fallback;
};

export const buildPartnershipSummaryFilename = ({
  patientName,
  displayedVisitDate,
}: {
  patientName?: string | null;
  displayedVisitDate?: string | null;
}): string =>
  `${sanitizeFilenamePart(patientName, "patient")}_${sanitizeFilenamePart(
    displayedVisitDate,
    "visit_date"
  )}_partnership_summary.docx`;
